<template lang="pug">
.post
    .tab
        .back(@click="$emit('fatherMethod' , { method : 'showPost' , data : false})")
            i.iconfont.icon-back
        .text 发布评论
        .postBtn(@click="post") 发布
    .area
        textarea(v-model="content" :placeholder="replyTips")
</template>
<script>

    import $ from "jquery";
    import appHelper from "../lib/appHelper";
    import util from "../lib/util";
    export default {
        name: 'postBox',
        props : {
            data : Object,
            postData : Object,
        },
        data : function(){
            return {
                content : "",
                replyTips : "说点什么吧"
            }
        },
        beforeMount : function(){
            if (typeof this.postData.username != 'undefined'){
                this.replyTips = '@' + this.postData.username;
            }
        },
        methods : {
            post : function(){
                if (this.content == ''){
                    alert('请输入您的评论！');
                    return;
                }
                let postData = {
                    article_id: this.data.articleId,
                    content : this.content
                };
                if (typeof this.postData.id != 'undefined'){
                    postData["parent_reply_id"] = this.postData.id;
                }

                $.post("/reply/create.html", postData , function(response) {
                    if (response.type == "succ") {
                        appHelper.alert("发布评论成功！");
                        util.reloadPage();
                    } else if (response.type == "err") {
                        appHelper.alert(response.msg);
                    }
                } , 'JSON');
            }
        }
    }

</script>


<style lang="scss">
    .icon-back:before {
        content: "\e65f";
    }
    .post{
        position: fixed;
        z-index:999999;
        background: #f2f2f2;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        .tab{
            height: 50px;
            line-height: 50px;
            background: #fff;
            display: flex;
            .back , .postBtn{
                width: 50px;
            }
            .back{
                text-indent: 10px;
            }
            .postBtn{
                text-align: right;
                padding-right: 10px;
            }
            .text{
                flex-grow: 1;
                text-align: center;
            }
        }
        .area{
            padding: 10px;
            textarea{
                width: 100%;
                height: 200px;
                border: 1px #fff solid;
                background: #fff;
                padding:5px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/post.vue